import { Route, Routes } from "react-router-dom";
import Sidebar from "./_components/Sidebar";
import InfoLayout from "components/InfoLayout";
import MainPage from "views/current-organisation/MainPage";

const HEADER_MAP = {
  "/": {
    title: "Current Organisation Settings",
    subtitle: "Manage your current org.",
  },
};

const getOrgKey = (location: Location): string => {
  const path = location.pathname.replace(/\/+$/, "").split("/").pop() || "";
  return path === "" ? "/" : `/${path}`;
};

const CurrentOrgInfo = () => {
  return (
    <InfoLayout
      Sidebar={Sidebar}
      headerMap={HEADER_MAP}
      getHeaderKey={getOrgKey}
    >
      <Routes>
        <Route path="/" element={<MainPage />} />
      </Routes>
    </InfoLayout>
  );
};

export default CurrentOrgInfo;
